import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { CompanyTelefon } from './company-telefon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-company-telefon-modal-update',
  templateUrl: './company-telefon-modal-update.component.html'
})
export class CompanyTelefonModalUpdateComponent extends BaseModalUpdateComponent<CompanyTelefon> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<CompanyTelefon>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
